module.exports = __webpack_public_path__ + "static/media/edit-photo.fae1f4b0.svg";